import { FormatModel } from "./format.model";

export class FormatDetailModel {
  formatDetailId: number = 0;
  formatId: number = 0;
  format: FormatModel = new FormatModel();
  name: string = '';
  description: string | null = null;
  band: string = 'head'; //"head", "foot", "body"
  type: string = 'label'; //"label", "p", "img"
  visible: boolean = false;
  left: number = 0;
  top: number = 0;
  width: number = 0;
  height: number = 0;
  fontSize: number = 0;
  bold: string = 'normal'; //"normal", "bold", "lighter"
  alignment: string = 'left'; //"left", "right", "center", "justify"
  border: string = 'noborder'; //"noborder", "border", "underline"
  text: string | null = null;
  orderTable: number = 0;
  printFormat: string | null = null; // "#,##0.00", "0.00%", etc.
}